import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCss3, faHtml5, faJs, faReact, faPython, faDocker } from '@fortawesome/free-brands-svg-icons';
import { faSass } from '@fortawesome/free-brands-svg-icons';
import { faC } from '@fortawesome/free-solid-svg-icons';
function Skills(){
    return(
        <section className="services" id="skills">
        <div className="title reveal">
          <h2 className="section-title">My Skills</h2>
          <p>Here are the languages I discovered and studied during my training with OpenClassRooms and Holberton School</p>
        </div>
        <div className="content">
          <div className="card reveal">
            <div className="info">
              <h3>HTML</h3>
             <FontAwesomeIcon className="iconfontawesome"icon={faHtml5} />
            </div>
          </div>
          <div className="card reveal">
            <div className="info">
              <h3>CSS</h3>
              <FontAwesomeIcon className="iconfontawesome"icon={faCss3} />
            </div>
          </div>
          <div className="card reveal">
            <div className="info">
              <h3>Sass</h3>
              <FontAwesomeIcon className="iconfontawesome"icon={faSass} />
            </div>
          </div>
          <div className="card reveal">
            <div className="info">
              <h3>JavaScript</h3>
              <FontAwesomeIcon className="iconfontawesome"icon={faJs} />
            </div>
          </div>
          <div className="card reveal">
            <div className="info">
              <h3>React</h3>
              <FontAwesomeIcon className="iconfontawesome"icon={faReact} />
            </div>
          </div>
		  <div className="card reveal">
            <div className="info">
              <h3>Python</h3>
              <FontAwesomeIcon className="iconfontawesome"icon={faPython} />
            </div>
          </div>
		  <div className="card reveal">
            <div className="info">
              <h3>C</h3>
              <FontAwesomeIcon className="iconfontawesome"icon={faC} />
            </div>
          </div>
		  <div className="card reveal">
            <div className="info">
              <h3>Docker</h3>
              <FontAwesomeIcon className="iconfontawesome"icon={faDocker} />
            </div>
          </div>
          
        </div>
      </section>
    )
}
export default Skills